import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from "./context/AuthContext";

ReactDOM.render(
    <GoogleOAuthProvider clientId="389197986997-i85goq07i6ulvnvumk9tplqm089r4og2.apps.googleusercontent.com">
        <AuthProvider>
            <App/>
        </AuthProvider>
    </GoogleOAuthProvider>,
    document.getElementById("root")
);
